import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import MDButton from 'components/MDButton';

export default function LowStockProducts({ closeModal }) {
  return (
    <Box className='cus-wrapper-drawer' sx={{ width: 480 }}>
      <Stack direction='row' alignItems='center' justifyContent='space-between' px={2} py={2} className='drawer-head-sec'>
        <Typography variant='h6' fontWeight='semibold'>Low Stock Products</Typography>
        <MDButton variant='text' onClick={closeModal}>Close</MDButton>
      </Stack>

      <Box className='drawer-scroll-sec drawer-scroll-without-footer' px={2}>
        <Typography variant='body2' color='text.secondary'>
          Coming soon: list of products that are low on stock for the selected distribution.
        </Typography>
      </Box>

      <Box className='drawer-bottom-btns' px={2} py={2}>
        <MDButton fullWidth variant='contained' color='primary' onClick={closeModal}>Done</MDButton>
      </Box>
    </Box>
  );
}


